import React from 'react';
import { motion } from 'framer-motion';

interface RatingStarsProps {
  rating: number;
  maxRating?: number;
}

const RatingStars: React.FC<RatingStarsProps> = ({ rating, maxRating = 5 }) => {
  const stars = Array.from({ length: maxRating }, (_, index) => {
    const isFilled = index < rating;
    return (
      <motion.span
        key={index}
        className={`material-symbols-outlined text-base !leading-none ${
          isFilled ? 'text-yellow-500' : 'text-gray-300 dark:text-gray-600'
        }`}
        initial={{ scale: 0.8 }}
        animate={{ scale: 1 }}
        transition={{ type: "spring", stiffness: 500, damping: 30, delay: index * 0.05 }}
      >
        {isFilled ? 'star' : 'star_border'}
      </motion.span>
    );
  });

  return (
    <div className="flex justify-center items-center gap-1">
      {stars}
    </div>
  );
};

export default RatingStars;